import gql from 'graphql-tag';

export const SpacesListSpaceFragment = gql`
	fragment SpacesListSpaceFragment on Space {
		alias @include(if: $includeAlias)
		id
		name
		key
		icon {
			path
		}
	}
`;
